<template>
  <div class="tutorial" :action="info.action" :position="info ? info.position : 'top'" :hposition="info ? info.hposition : 'center'" :arrow="info ? info.arrow : false" ref="tut" v-show="visible && info">
    <div class="tutorial-close" @click="closeTut(challenge)"><img src="@/assets/img/close-white.svg" width="16" height="16"></div>
    <div class="tutorial-title" v-if="info">{{info.title}}</div>
    <div class="tutorial-desc" v-if="info">{{info.desc}}</div>
    <div class="tutorial-sep"></div>
    <div class="tutorial-buttons" v-if="info && !info.finish && (info.prev || info.next)">
      <div class="tutorial-button-label" @click="prevHint()">Prev</div>
      <div class="tutorial-button button-prev" @click="prevHint()" :notavailable="info && !info.prev"></div>
      <div class="tutorial-button button-next" @click="nextHint()" :notavailable="info && !info.next"></div>
      <div class="tutorial-button-label label-next" @click="nextHint()">Next</div>
    </div>
    <div class="tutorial-buttons" v-if="info && info.finish">
      <div class="tutorial-finish" @click="finishTutorial()">Finish</div>
    </div>
    <div class="tutorial-buttons" v-if="info && info.button">
      <div class="tutorial-finish" @click="buttonAction(info)">{{info.button}}</div>
    </div>
    <div class="tutorial-point" ref="point"></div>
  </div>
</template>

<script>
import references from '@/assets/json/references.json'
import simulation from '@/lib/simulation.js'

const keys = Object.keys(references)
for (const idx in keys) {
  const next = 1 + idx * 1
  const start = references[keys[idx]].start
  const end = references[keys[idx]].end
  references[keys[idx]].prev = keys[idx - 1] && !start ? keys[idx - 1] : null
  references[keys[idx]].next = keys[next] && !end ? keys[next] : null
}

const keyMonitor = function (ev) {
  if (this.updating) {
    return
  }
  if (this.visible) {
    if (ev.keyCode === 39) {
      this.nextHint()
    }
    if (ev.keyCode === 37) {
      this.prevHint()
    }
  }
}

export default {
  name: 'comp',
  data: function () {
    return {
      current: null,
      visible: false,
      lastState: {},
      info: {},
      clickEl: null
    }
  },
  props: {
    reference: String,
    challenge: Number,
    view: String
  },
  mounted: function () {
    if (this.view === 'pumpcontrol') {
      this.setCurrent(this.reference)
    }
    window.addEventListener('resize', this.updatePosition.bind(this))
    window.addEventListener('keyup', keyMonitor.bind(this))
    window.tut = this
  },
  methods: {
    buttonAction: function (item) {
      if (item.action) {
        simulation.action(item.action)
      }
      if (item.continue) {
        this.continue()
      }
      this.$forceUpdate()
    },
    setCurrent: function (value) {
      simulation.data.tutorialId = value
      this.current = simulation.data.tutorialId
      this.visible = false
      this.info = references[this.current]
      if (this.lastState[simulation.data.tutorialId] && simulation.challengeNumber === 0) {
        const data = this.lastState[simulation.data.tutorialId]
        for (const key in data) {
          simulation.data[key] = data[key]
        }
      }
      if (this.info && this.info.load) {
        simulation[this.info.load]()
      }
      this.updatePosition()
      this.$emit('change', this.current)
    },
    closeTut: function (challenge) {
      if (challenge === 0) {
        this.$emit('exit', this.current)
      } else {
        this.continue()
      }
    },
    continue: function () {
      this.clearClickable()
      this.setCurrent(0)
      simulation.startMonitor()
      this.$forceUpdate()
    },
    updatePosition: function () {
      this.current = simulation.data.tutorialId
      this.info = references[this.current]
      const tut = this.$refs.tut
      const current = this.current
      const point = this.$refs.point
      const self = this
      this.visible = (current !== null)
      if (tut) {
        tut.style.opacity = 0
        tut.style.visibility = 'hidden'
      }
      if (point) {
        point.style.display = 'none'
      }
      if (this.current) {
        const updateProc = function () {
          self.$nextTick(function () {
            if (simulation.challengeNumber === 0) {
              self.lastState[self.current] = JSON.parse(JSON.stringify(simulation.data))
            }
          })
          let selector = '#' + current.split('.')[0]
          if (self.info.selector) {
            selector = self.info.selector
          }
          const sourceObj = document.querySelector(selector)
          let obj = sourceObj
          self.updating = false
          if (!obj) {
            return
          }
          if (!tut) {
            return
          }
          const rect = obj.getBoundingClientRect()
          const style = getComputedStyle(obj)
          const trect = tut.getBoundingClientRect()
          let curleft = 0
          let curtop = 0
          while (obj) {
            if (obj === tut.parentNode) {
              break
            }
            curleft += obj.offsetLeft
            curtop += obj.offsetTop
            obj = obj.offsetParent
          }
          const vpos = self.info ? self.info.position : 'top'
          const hpos = self.info && self.info.hposition ? self.info.hposition : 'center'
          const hdiff = (rect.width - trect.width) / 2
          const vdiff = (rect.height - trect.height) / 2
          let hoffset = 0
          if (hpos === 'center') {
            hoffset = hdiff
          }
          if (hpos === 'left') {
            hoffset = 0
          }
          let vtransf = 0
          if (style.transform) {
            const parts = style.transform.replace(')', '').split(', ')
            if (parts[4]) {
              hoffset += parts[4] * 1.0
            }
            if (parts[5]) {
              vtransf = parts[5] * 1.0
            }
          }
          let voffset = 2
          tut.style.width = ''
          if (self.info.width) {
            tut.style.width = self.info.width
          }
          if (vpos === 'bottom') {
            if (self.info.offsety) {
              voffset = self.info.offsety
            }
            if (curtop + rect.height + voffset + trect.height > window.innerHeight) {
              tut.style.width = '290px'
              vtransf -= 10
            }
            tut.style.top = (curtop + rect.height + voffset + vtransf) + 'px'
            if (self.info.arrow) {
              tut.style.top = (curtop + rect.height + 8 + voffset + vtransf) + 'px'
            }
          }
          if (vpos === 'top') {
            tut.style.top = (curtop - trect.height - 2) + 'px'
            if (self.info.arrow) {
              tut.style.top = (curtop - trect.height - 8) + 'px'
            }
          }
          if (vpos === 'left') {
            tut.style.top = (curtop + vdiff) + 'px'
            hoffset = -trect.width
            if (self.info.arrow) {
              hoffset = -trect.width - 10
            }
          }
          if (vpos === 'right') {
            tut.style.top = (curtop + vdiff) + 'px'
            hoffset = rect.width
            if (self.info.arrow) {
              hoffset = rect.width + 10
            }
          }
          tut.style.left = (curleft + hoffset) + 'px'
          point.style.width = rect.width + 'px'
          point.style.height = rect.height + 'px'
          if (vpos === 'top' || vpos === 'bottom') {
            point.style.marginTop = ''
            point.style.marginLeft = (-rect.width / 2) + 'px'
          }
          if (vpos === 'left') {
            point.style.left = ''
            point.style.right = (-rect.width - 13) + 'px'
            point.style.marginTop = (-rect.height / 2) + 'px'
            point.style.marginLeft = ''
          }
          if (vpos === 'right') {
            point.style.right = ''
            point.style.left = (-rect.width - 13) + 'px'
            point.style.marginTop = (-rect.height / 2) + 'px'
            point.style.marginLeft = ''
          }
          point.style.display = ''
          self.clearClickable()
          self.clickEl = document.querySelector(selector)
          if (self.info.clickItem) {
            self.clickEl = document.querySelector(self.info.clickItem)
          }
          if (self.clickEl && (self.info.action || self.info.continue) && self.info.arrow) {
            self.clickEl.style.zIndex = 10
            self.clickEl.style.cursor = 'pointer'
            // self.clickEl.style.boxShadow = '0 0 5px 3px rgba(64,192,192,0.5)'
            self.clickEl.style.opacity = '1'
            self.clickEl.clickFunc = function (ev) {
              if (self.current) {
                self.nextHint()
                ev.preventDefault()
                ev.cancelBubble = true
              }
            }
            self.clickEl.addEventListener('click', self.clickEl.clickFunc)
          }
          // console.log('pos', hpos, tut.style.left, tut.style.top)
          // show
          self.visible = true
          tut.style.opacity = 1
          tut.style.visibility = ''
        }
        self.updating = true
        setTimeout(function () {
          simulation.stopMonitor()
          if (self.info && self.info.time) {
            simulation.forwardToTime(self.info.time, updateProc)
          } else {
            self.updating = false
          }
        }, 300)
      } else {
        self.visible = false
      }
    },
    clearClickable: function () {
      if (this.clickEl) {
        this.clickEl.style.zIndex = ''
        this.clickEl.style.cursor = ''
        this.clickEl.style.boxShadow = ''
        this.clickEl.style.opacity = ''
        this.clickEl.removeEventListener('click', this.clickEl.clickFunc)
      }
    },
    prevHint: function () {
      this.clearClickable()
      if (this.info.prev) {
        delete this.lastState[this.current]
        this.setCurrent(this.info.prev)
      }
    },
    nextHint: function () {
      this.clearClickable()
      if (this.info.finish) {
        this.finishTutorial()
        return
      }
      if (this.info.action) {
        simulation.action(this.info.action)
      }
      if (this.info.action === 'continue' || this.info.continue) {
        this.continue()
      } else if (this.info.next) {
        delete this.lastState[this.info.next]
        this.setCurrent(this.info.next)
      }
    },
    finishTutorial: function () {
      this.clearClickable()
      if (this.info.action) {
        simulation.action(this.info.action)
      }
      this.setCurrent(null)
    }
  },
  watch: {
    reference: function (newValue) {
      if (!newValue) {
        this.lastState = {}
      }
      this.setCurrent(newValue)
      this.updatePosition()
    }
  }
}
</script>

<style scoped lang="scss">
.tutorial {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 3;
  width: 245px;
  min-height: 160px;
  background-color: #00B5E2;
  color: #fff;
  border-radius: 5px;
  transition: opacity linear .2s;
  text-align: left;
  padding: 16px 0 8px 0;
  box-shadow: 1px 1px 3px 2px rgba(128,128,128,0.3);
  >div{
    padding-left: 16px;
    padding-right: 16px;
  }
  .tutorial-point{
    position: absolute;
    width: 30px;
    height: 30px;
    display: none;
    border-radius: 7px;
    z-index: 5;
  }
  &[position]::after{
    width: 20px;
    height: 20px;
    margin: 0 auto;
    background: transparent;
    border-top: 10px solid #00B5E2;
    border-bottom: 10px solid transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
    z-index: 3;
  }
  &[position='bottom'][arrow='true']{
    &::after{
      border-bottom: 10px solid #00B5E2;
      border-top: 10px solid transparent;
      top: -20px;
      left: 48%;
      content: ' '
    }
    .tutorial-point{
      top: -42px;
      left: 48%;
    }
  }
  &[position='bottom'][hposition='left'][arrow='true']::after{
    left: 32px;
  }
  &[position='bottom'][hposition='left'][arrow='true'] .tutorial-point{
    left: 32px;
  }
  &[position='top'][arrow='true']{
    &::after{
      border-top: 10px solid #00B5E2;
      border-bottom: 10px solid transparent;
      content: ' ';
      bottom: -20px;
      left: 48%;
      content: ' '
    }
    .tutorial-point{
      bottom: -110%;
      left: 51%;
    }
  }
  &[position='left'][arrow='true']{
    &::after{
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid transparent;
      border-left: 10px solid #00B5E2;
      content: ' ';
      top: 45%;
      right: -20px;
      content: ' '
    }
    .tutorial-point{
      top: 51%;
      right: -42px;
    }
  }
  &[position='right'][arrow='true']{
    &::after{
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid transparent;
      border-right: 10px solid #00B5E2;
      content: ' ';
      top: 45%;
      left: -20px;
      content: ' '
    }
    .tutorial-point{
      top: 51%;
      left: -42px;
    }
  }
}
.tutorial[arrow=true][action]{
  .tutorial-point{
    display: block;
  }
}
.tutorial-close{
  cursor: pointer;
  position: absolute;
  padding: 0 !important;
  width: 30px;
  height: 30px;
  right: 9px;
  top: 9px;
  border-radius: 15px;
  background-color: #00BEEE;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;
  &:hover{
    background-color: #005EB8;
  }
  img {
    width: 12px;
    height: 12px;
  }
}
.tutorial-title{
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 14px;
  margin-right: 28px;
  min-height: 24px;
}
.tutorial-desc{
  font-size: 16px;
  flex: 1;
}
.tutorial-sep{
  border-top: 2px solid #00BEEE;
  height: 12px;
  margin-top: 16px;
}
.tutorial-buttons{
  display: flex;
  justify-content: center;
  align-items: center;
  .tutorial-button{
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: center center;
    border-radius: 3px;
    width: 40px;
    height: 40px;
    margin: 0 5px;
    cursor: pointer;
  }
  .tutorial-button-label{
    font-weight: bold;
    flex: 1;
    text-align: center;
    cursor: pointer;
  }
  .button-prev{
    background-image: url('../assets/img/gfx_arrow_left.svg');
    transition: background-image 0.2s;
    &:not([notavailable='true']):hover{
      background-image: url('../assets/img/gfx_arrow_left_hover.svg');
    }
  }
  .button-next{
    background-image: url('../assets/img/gfx_arrow_left.svg');
    transition: background-image 0.2s;
    transform: rotate(180deg);
    &:not([notavailable='true']):hover{
      background-image: url('../assets/img/gfx_arrow_left_hover.svg');
    }
  }
  *[notavailable='true']{
    opacity: 0.7;
    cursor: default;
  }
  .tutorial-finish{
    height: 36px;
    background-color: #fff;
    border-radius: 20px;
    border: 2px solid #BCE0FD;
    color: #00BEEE;
    min-width: 80px;
    text-align: center;
    line-height: 32px;
    font-weight: bold;
    padding: 0 16px;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;
    transition: color 0.2s;
    &:hover{
      color: #005EB8;
    }
  }
}
@media (max-height: 800px) , (max-width:1279px) {
  .tutorial-sep{
    margin-top: 8px;
    height: 10px;
  }
  .tutorial-title{
    font-size: 16px;
    min-height: 20px;
  }
  .tutorial-desc{
    font-size: 14px;
    line-height: 1.3em;
  }
  .tutorial-buttons .tutorial-button{
    width: 36px;
    height: 36px;
  }
}
@media (max-height: 660px) {
  .tutorial{
    width: 220px;
    min-height: 150px;
    padding-top: 10px;
  }
  .tutorial-close {
    width: 24px;
    height: 24px;
  }
  .tutorial-sep{
    margin-top: 6px;
    height: 8px;
  }
  .tutorial-title{
    font-size: 14px;
    min-height: 18px;
  }
  .tutorial-desc{
    font-size: 13px;
    line-height: 1.3em;
  }
  .tutorial-buttons .tutorial-button{
    width: 26px;
    height: 26px;
  }
  .tutorial-buttons .tutorial-button-label{
    font-size: 14px;
  }
  .tutorial-buttons .tutorial-finish{
    padding: 0 12px;
    font-size: 12px;
    height: 32px;
    line-height: 29px;
  }
}
@media (max-height: 600px) {
  .tutorial{
    min-height: 136px;
    padding-top: 8px;
  }
  .tutorial-title{
    margin-bottom: 4px;
  }
  .tutorial-close{
    top: 5px;
  }
  .tutorial-buttons .tutorial-button{
    width: 22px;
    height: 22px;
    background-size: 14px 14px;
    &.button-prev{
      margin-left: -8px;
      margin-right: 8px;
    }
    &.button-next{
      margin-left: 8px;
      margin-right: -8px;
    }
  }
}
</style>
